"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSound = createSound;
exports.createSoundSprite = createSoundSprite;
exports.fadeSound = fadeSound;
exports.loopSound = loopSound;
exports.playSound = playSound;
exports.raiseSound = raiseSound;
exports.rateSound = rateSound;
exports.setPlayRate = setPlayRate;
exports.stopSound = stopSound;
var _types = require("./types");
function createSound(sounds, files, volume, autoplay, loop) {
  return {
    type: _types.SOUND_CREATE,
    payload: {
      sounds: sounds,
      files: files,
      volume: volume,
      autoplay: autoplay,
      loop: loop
    }
  };
}
function createSoundSprite(sound, sprite, files, volume, autoplay, loop) {
  return {
    type: _types.SOUND_CREATE_SPRITE,
    payload: {
      sound: sound,
      sprite: sprite,
      files: files,
      volume: volume,
      autoplay: autoplay,
      loop: loop
    }
  };
}

/**
 * Start a sound
 *
 * @param sound
 * @param onlyOnce
 * @param spriteId
 * @param volume
 * @param force by pass device lock check
 * @param stereo -1 is all left, 1 is all right, 0 is middle
 */
function playSound(sound, onlyOnce, spriteId, volume, force, stereo, delay) {
  return {
    type: _types.SOUND_PLAY,
    payload: {
      sound: sound,
      onlyOnce: onlyOnce,
      spriteId: spriteId,
      volume: volume,
      force: force,
      stereo: stereo,
      delay: delay
    }
  };
}
function stopSound(sound, fadeTime, spriteId) {
  return {
    type: _types.SOUND_STOP,
    payload: {
      sound: sound,
      fadeTime: fadeTime,
      spriteId: spriteId
    }
  };
}
function rateSound(sound, spriteId, rate) {
  return {
    type: _types.SOUND_PLAY_RATE,
    payload: {
      sound: sound,
      spriteId: spriteId,
      rate: rate
    }
  };
}

/**
 * fade sounds up and down, will fade in what ever direction is needed based on the from or to. So can both increase and lower.
 * @param sound 
 * @param spriteId 
 * @param from 
 * @param to 
 * @param duration 
 * @returns 
 */
function fadeSound(sound, spriteId, from, to, duration) {
  return {
    type: _types.SOUND_FADE,
    payload: {
      sound: sound,
      from: from,
      to: to,
      duration: duration,
      spriteId: spriteId
    }
  };
}
/**
 * Raise the volume of a sound, wont lower and if its alreay higher it wont do anything. used to increase anticipation as things happens.
 * @param sound 
 * @param spriteId 
 * @param to 
 * @param duration 
 * @returns 
 */
function raiseSound(sound, spriteId, to, duration) {
  return {
    type: _types.SOUND_RAISE,
    payload: {
      sound: sound,
      to: to,
      duration: duration,
      spriteId: spriteId
    }
  };
}
function loopSound(sound, spriteId, loop, actionOnEnd) {
  return {
    type: _types.SOUND_LOOP,
    payload: {
      sound: sound,
      spriteId: spriteId,
      loop: loop,
      actionOnEnd: actionOnEnd
    }
  };
}
function setPlayRate(sound, spriteId, rate) {
  return {
    type: _types.SOUND_PLAY_RATE,
    payload: {
      sound: sound,
      rate: rate,
      spriteId: spriteId
    }
  };
}
//# sourceMappingURL=actions.js.map